/* Seren × Apple — shared motion for sap sections.
   Everything is visible by default. Elements that start below the fold are
   marked .sap-wait and lifted in (.in) as they scroll into view; anything
   already on screen when this script runs is shown as-is, so the first
   paint never waits for JavaScript. Counters ease out, accordions toggle,
   marquees are duplicated for a seamless loop. Reduced motion → nothing
   waits and counters show their final value straight away. */
(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function ease(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  /* shared nav-height custom property (sticky offsets read it) */
  function setNavHeight() {
    var nav = document.querySelector(".nav");
    if (nav) {
      document.documentElement.style.setProperty(
        "--sap-nav-h",
        nav.offsetHeight + "px",
      );
    }
  }
  setNavHeight();
  window.addEventListener("resize", setNavHeight, { passive: true });

  /* accordion toggle — bound in every code path */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".sap-acc-btn");
    if (!btn) return;
    var item = btn.closest(".sap-acc-item");
    if (!item) return;
    item.classList.toggle("open");
    btn.setAttribute(
      "aria-expanded",
      item.classList.contains("open") ? "true" : "false",
    );
  });

  function show(el) {
    el.classList.remove("sap-wait");
    el.classList.add("in");
  }
  function finishCount(el) {
    el.textContent =
      el.getAttribute("data-sap-count") +
      (el.getAttribute("data-sap-suffix") || "");
  }
  function dupMarquee(scope) {
    scope
      .querySelectorAll(".sap-marquee-track:not([data-dup])")
      .forEach(function (t) {
        t.setAttribute("data-dup", "1");
        t.innerHTML += t.innerHTML;
      });
  }
  function inView(rect) {
    var h = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < h && rect.bottom > 0;
  }
  function scopeOf(root) {
    return root && root.querySelectorAll ? root : document;
  }

  /* no IntersectionObserver, or reduced motion → show everything at once */
  if (!("IntersectionObserver" in window) || reduce) {
    var revealAll = function (root) {
      var scope = scopeOf(root);
      scope.querySelectorAll("[data-sap-rv], .sap-bar").forEach(show);
      scope.querySelectorAll("[data-sap-count]").forEach(finishCount);
      dupMarquee(scope);
    };
    ready(function () {
      revealAll(document);
    });
    document.addEventListener("shopify:section:load", function (e) {
      revealAll(e.target);
    });
    window.SapMotion = { arm: revealAll, revealVisible: revealAll };
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          show(e.target);
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: "0px 0px -60px 0px", threshold: 0.05 },
  );

  var cio = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target;
        var target = parseFloat(el.getAttribute("data-sap-count"));
        if (isNaN(target)) return;
        var dec = (
          String(el.getAttribute("data-sap-count")).split(".")[1] || ""
        ).length;
        var suffix = el.getAttribute("data-sap-suffix") || "";
        var t0 = null;
        function frame(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 900, 1);
          el.textContent = (target * ease(p)).toFixed(dec) + suffix;
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    },
    { threshold: 0.4 },
  );

  /* Arm a subtree. Every rect is read first and the classes are written
     afterwards, so the browser lays the page out once, not once per element.
     Elements already on screen are shown as-is (no animation); the rest wait
     for the observer. */
  function arm(root) {
    var scope = scopeOf(root);
    var els = Array.prototype.slice.call(
      scope.querySelectorAll("[data-sap-rv]:not(.in), .sap-bar:not(.in)"),
    );
    var rects = els.map(function (el) {
      return el.getBoundingClientRect();
    });
    els.forEach(function (el, i) {
      if (inView(rects[i])) {
        show(el);
      } else {
        el.classList.add("sap-wait");
        io.observe(el);
      }
    });
    scope.querySelectorAll("[data-sap-count]").forEach(function (el) {
      cio.observe(el);
    });
    dupMarquee(scope);
  }

  /* Safety net: browsers pause IntersectionObserver in background tabs, so a
     page opened via cmd-click or restored from the back-forward cache could
     otherwise leave on-screen elements waiting. */
  function revealVisible() {
    document
      .querySelectorAll("[data-sap-rv].sap-wait, .sap-bar:not(.in)")
      .forEach(function (el) {
        if (inView(el.getBoundingClientRect())) show(el);
      });
    document.querySelectorAll("[data-sap-count]").forEach(function (el) {
      if (
        inView(el.getBoundingClientRect()) &&
        el.textContent.trim().charAt(0) === "0"
      ) {
        cio.unobserve(el);
        finishCount(el);
      }
    });
  }

  ready(function () {
    arm(document);
    setTimeout(revealVisible, 1200);
  });

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) setTimeout(revealVisible, 300);
  });
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) revealVisible();
  });

  /* theme editor: re-arm when sections load/reorder */
  document.addEventListener("shopify:section:load", function (e) {
    arm(e.target);
    setTimeout(revealVisible, 300);
  });

  window.SapMotion = { arm: arm, revealVisible: revealVisible };
})();
